import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import Dialog from '../../common/components/Dialog';
import WeeklyInfo from '../home/WeeklyInfo';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import utils from '../../common/services/utils';

class LessonsDialog extends Component {
	renderBody() {
		const { t, lessons, blocking, enableUserTimeZone, center } = this.props;

		return (
			<div>
				<BlockUi blocking={blocking}>
					{lessons && <Table className='table-condensed table-hover'>
						<thead>
							<tr>
								<th>{t('FO_ChildLesson_Date')}</th>
								<th>{t('FO_ChildLesson_Type')}</th>
								<th>{t('FO_ChildLesson_Attendance')}</th>
							</tr>
						</thead>
						<tbody>
							{lessons.map(lesson => (<tr key={lesson.id}>
								<td><WeeklyInfo lesson={lesson}
									showInfo={!lesson.isInTheFuture && lesson.hasPaidAccessInTerm}
									weeklyInfos={this.props.weeklyInfos}
									onLoadWeeklyInfo={subGrade => this.props.onLoadWeeklyInfo(lesson, subGrade)}
									allowSubGradeChange={false}
									grades={this.props.grades}
									onSubGradeSelect={(grade, onSuccess) => this.props.onSubGradeSelect(lesson, grade, onSuccess)}
									subGradeBlock={this.props.subGradeBlock}
									subGradeUnblock={this.props.subGradeUnblock}
									weeklyInfoBlock={this.props.weeklyInfoBlock}
									weeklyInfoUnblock={this.props.weeklyInfoUnblock}
								/>: {(enableUserTimeZone ? utils.convertToUserTime(lesson.start, center) : moment(lesson.start)).format('lll')}</td>
								<td>{t(`LessonType_${lesson.type}`)}</td>
								<td>{lesson.isHoliday ? t('FO_ChildLesson_Holiday') : lesson.isAttended ? t('Common_Yes') : t('Common_No')}</td>
							</tr>))}
						</tbody>
					</Table>}
				</BlockUi>
			</div>
		);
	}

	render() {
		const { onCancel, lessons, blocking, title, t, ...rest } = this.props;
		return <Dialog onHide={onCancel} header={title} body={this.renderBody()} {...rest} />;
	}
}

LessonsDialog.propTypes = {
	lessons: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		start: PropTypes.string,
		type: PropTypes.shape({ name: PropTypes.string }),
		isAttended: PropTypes.bool
	})),
	title: PropTypes.string,
	onCancel: PropTypes.func.isRequired,
	blocking: PropTypes.bool
};

export default withNamespaces()(LessonsDialog);